<template>
  <div class="h-screen overflow-hidden w-screen">
    <img alt="Logo" class="h-10 m-10" src="@/assets/images/logo-inverted.svg" />
    <div
      v-if="isLoading"
      class="-translate-x-1/2 -translate-y-1/2 absolute left-1/2 top-1/2 transform"
    >
      <i class="loading" />
      <img
        alt="Icon"
        class="-translate-x-1/2 -translate-y-1/2 absolute top-1/2 left-1/2 h-12 w-12"
        src="@/assets/images/icon.svg"
      />
    </div>
    <div
      v-else-if="isSucceed"
      class="flex flex-col items-center justify-center mt-32 px-5 sm:mt-13"
    >
      <h1 class="font-medium mb-8 sm:text-2xl text-black text-[32px]">
        密碼重置成功
      </h1>
      <div class="flex flex-col items-center justify-center mb-14">
        <p class="text-black">密碼已重置為：</p>
        <p class="leading-[48px] text-primary-500 text-[32px]">{{ password }}</p>
        <span class="text-[#4F5865] text-sm">(a+組織統編)</span>
        <p class="mt-3 text-black">請組織成員以預設密碼登入後再自行修改個人密碼。</p>
      </div>
      <img
        alt="Verification failed"
        class="h-72 sm:h-40"
        src="@/assets/images/oc-unlock.svg"
      />
    </div>
    <div v-else class="flex flex-col items-center justify-center mt-36 px-5 sm:mt-14">
      <h1
        class="font-medium mb-8 sm:text-2xl text-black text-[32px]"
      >
        {{ errors.title }}
      </h1>
      <div
        v-if="errors.messages.length"
        class="flex flex-col items-center mb-14"
      >
        <span
          v-for="(message, index) in errors.messages"
          :key="`error-message-${index}`"
          class="text-black"
        >
          {{ message }}
        </span>
      </div>
      <img
        alt="Verification failed"
        class="h-72 sm:h-40"
        src="@/assets/images/lock-disconnected.svg"
      />
    </div>
    <div class="copyright">
      Copyright © {{ dayjs().year() }}
      <a href="https://weiby.tw/" target="_blank">微碧愛普科技有限公司.</a>
      保留一切權利。
    </div>
  </div>
</template>

<script>
import ResetPasswordVerification from './ResetPasswordVerification';

export default ResetPasswordVerification;
</script>

<style lang="scss" scoped>
@import 'ResetPasswordVerification';
</style>
